import { render, staticRenderFns } from "./FormRichEditor.vue?vue&type=template&id=01e57188&"
import script from "./FormRichEditor.vue?vue&type=script&lang=js&"
export * from "./FormRichEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormRichEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports